import { Button, ButtonGroup, HStack, MixpanelEvent, MixpanelEventProperty, useMixpanel } from '@talos/kyoko';
import { useMarketSelectorContext } from '../MarketSelectorContext';

export const MobileMarketSelectorBlotterActionItems = () => {
  const { selectionsSet, unselectAll, selectAll, isNarrow } = useMarketSelectorContext();
  const mixpanel = useMixpanel();

  const handleSelectAll = () => {
    mixpanel.track(MixpanelEvent.UpdateMarketSelection, {
      [MixpanelEventProperty.Method]: 'SelectAll',
    });
    selectAll();
  };

  const handleClearAll = () => {
    mixpanel.track(MixpanelEvent.UpdateMarketSelection, {
      [MixpanelEventProperty.Method]: 'ClearAll',
    });
    unselectAll();
  };

  return (
    <HStack gap="spacing16">
      <ButtonGroup flex="1">
        <Button onClick={handleSelectAll} data-testid="market-selector-blotter-select-all">
          Select All
        </Button>
        <Button
          disabled={selectionsSet.size === 0}
          onClick={handleClearAll}
          data-testid="market-selector-blotter-clear"
        >
          Clear{!isNarrow ? ' All' : ''}
        </Button>
      </ButtonGroup>
    </HStack>
  );
};
